export default __webpack_public_path__ + "upload/2.1e2dd5b7.png";